import { notification } from "antd";
import { ArgsProps } from "antd/es/notification/interface";

export function Notification() {
  const [_, contextHolder] = notification.useNotification();

  function openNotification(config: ArgsProps) {
    notification.open(config);
  }

  function closeNotification(notificationKey: string) {
    notification.destroy(notificationKey);
  }

  return { contextHolder, openNotification, closeNotification };
}
